import { WAREHOUSE_TYPES } from "../../../../../utils/warehouses/constants.js";
import { getWarehouseType } from "../../../../../utils/warehouses/getWarehouseType.js";
import { SEARCH_FAILURE_TEXT_KEY, UNABLE_TO_DETERMINE_AVAILABILITY_ALERT_TEXT_KEY, OUT_OF_STOCK_ALERT_TEXT_KEY, PRODUCT_UNAVAILABLE_ALERT_TEXT_KEY } from "../../../../../utils/warehouses/warehouseDrawer.constants.js";
const shouldShowSetWarehouseButton = (locale, warehouse, drawerType, isPreferredWarehouse) => {
  var _a, _b;
  const warehouseType = getWarehouseType(warehouse);
  if (warehouseType === WAREHOUSE_TYPES.BUSINESS_CENTER || warehouseType === WAREHOUSE_TYPES.SHOWROOM) {
    return false;
  }
  return (locale == null ? void 0 : locale.includes((_a = warehouse == null ? void 0 : warehouse.address) == null ? void 0 : _a.countryName.toLowerCase())) && (drawerType === "CMW" ? "stockStatus" in warehouse && ((_b = warehouse == null ? void 0 : warehouse.stockStatus) == null ? void 0 : _b.showWHSMolecule) === true : drawerType === "FMW" ? !isPreferredWarehouse : true);
};
const getWHListDetails = (warehouseList, featureConfigs, enabledWarehouseListLucid, enabledWarehouseListBopiw, enabledWarehouseListWio, productFlags) => {
  const { isBopiwProduct, isWioProduct } = productFlags || {};
  const {
    warehouseChannel_feature_on = true,
    bopiwOrStw_feature_on = true,
    wio_feature_on = true
  } = (featureConfigs == null ? void 0 : featureConfigs.custom) || {};
  return warehouseList.map((warehouse) => {
    const isWarehouseWioEnabled = (enabledWarehouseListLucid == null ? void 0 : enabledWarehouseListLucid.has(warehouse)) && (enabledWarehouseListWio == null ? void 0 : enabledWarehouseListWio.has(warehouse));
    const isWarehouseBopiwEnabled = (enabledWarehouseListLucid == null ? void 0 : enabledWarehouseListLucid.has(warehouse)) && (enabledWarehouseListBopiw == null ? void 0 : enabledWarehouseListBopiw.has(warehouse));
    const isWarehouseWioEligible = warehouseChannel_feature_on && wio_feature_on && isWarehouseWioEnabled;
    const isWarehouseBopiwEligible = warehouseChannel_feature_on && bopiwOrStw_feature_on && isWarehouseBopiwEnabled;
    if (isBopiwProduct && isWioProduct && (isWarehouseBopiwEligible || isWarehouseWioEligible)) {
      return {
        fulfillmentCenter: warehouse,
        showWHSMolecule: "true"
      };
    } else if (isWioProduct && isWarehouseWioEligible) {
      return {
        fulfillmentCenter: warehouse,
        showWHSMolecule: "true"
      };
    } else if (isBopiwProduct && isWarehouseBopiwEligible) {
      return {
        fulfillmentCenter: warehouse,
        showWHSMolecule: "true"
      };
    } else {
      return {
        fulfillmentCenter: warehouse,
        showWHSMolecule: "false"
      };
    }
  });
};
const categorizeWH = (warehouseListDetails, isEligibleForSTW) => {
  const enabledWarehouses = [];
  const disabledWarehouses = [];
  warehouseListDetails.forEach(({ fulfillmentCenter, showWHSMolecule }) => {
    if (isEligibleForSTW || showWHSMolecule === "true") {
      enabledWarehouses.push(fulfillmentCenter);
    } else {
      disabledWarehouses.push(fulfillmentCenter);
    }
  });
  return {
    disabledWarehouses,
    enabledWarehouses
  };
};
const getWHStockStatus = (warehouse, inWarehouse, useWarehouseInventory) => {
  const warehouseId = `${warehouse == null ? void 0 : warehouse.warehouseId}-wh`;
  const warehouseInfo = (inWarehouse == null ? void 0 : inWarehouse.find((wh) => (wh == null ? void 0 : wh.fulfillmentCenter) === warehouseId)) ?? {};
  const isInStock = warehouseInfo && ((warehouseInfo == null ? void 0 : warehouseInfo.availability) === "INSTOCK" || (warehouseInfo == null ? void 0 : warehouseInfo.availability) === "LOWSTOCK");
  const inventory = (useWarehouseInventory == null ? void 0 : useWarehouseInventory.find(
    (wh) => (wh == null ? void 0 : wh.fulfillmentCenter) === warehouseId
  )) ?? {};
  const useWarehouseInventoryAvailability = inventory == null ? void 0 : inventory.availability;
  const stockStatus = {
    showWHSMolecule: true,
    ...warehouseInfo,
    ...inventory,
    useWarehouseInventoryAvailability
  };
  return {
    isInStock,
    stockStatus
  };
};
const getAvailableWHList = (warehouses, fulfillmentCenters, inWarehouse, useWarehouseInventory) => {
  const selectedWHList = warehouses.filter(
    (warehouse) => fulfillmentCenters.includes(`${warehouse == null ? void 0 : warehouse.warehouseId}-wh`)
  );
  const updatedWarehouses = selectedWHList.map((warehouse) => {
    const { isInStock, stockStatus } = getWHStockStatus(
      warehouse,
      inWarehouse,
      useWarehouseInventory
    );
    return {
      ...warehouse,
      isInStock,
      stockStatus
    };
  });
  return updatedWarehouses;
};
const getUnavailableWHList = (warehouses, disabledWarehouses) => {
  if (disabledWarehouses.length === 0) return [];
  return warehouses.filter(
    (warehouse) => disabledWarehouses.includes(`${warehouse == null ? void 0 : warehouse.warehouseId}-wh`)
  ).map((warehouse) => {
    return {
      ...warehouse,
      isInStock: false,
      stockStatus: {
        showWHSMolecule: false
      }
    };
  });
};
const markAllWHAsUnavailable = (warehouses) => {
  return (warehouses == null ? void 0 : warehouses.map((warehouse) => ({
    ...warehouse,
    isInStock: false,
    stockStatus: { showWHSMolecule: false }
  }))) || [];
};
const getWHToDisplay = async (warehouses, checked, preferredWarehouse) => {
  const isPreferedWarehouse = (warehouse) => warehouse.warehouseId === preferredWarehouse;
  const isInStock = (warehouse) => {
    var _a;
    return warehouse.isInStock === true || ((_a = warehouse.stockStatus) == null ? void 0 : _a.useWarehouseInventoryAvailability) && ["INSTOCK", "LOWSTOCK"].includes(
      warehouse.stockStatus.useWarehouseInventoryAvailability
    );
  };
  const isEnabled = (warehouse) => {
    var _a;
    return ((_a = warehouse.stockStatus) == null ? void 0 : _a.showWHSMolecule) === true;
  };
  let displayedWarehouses;
  if (checked) {
    displayedWarehouses = warehouses.filter((warehouse) => {
      return isPreferedWarehouse(warehouse) || isInStock(warehouse);
    });
    if (displayedWarehouses.length === 1) {
      const updatedWarehouse = {
        ...displayedWarehouses[0],
        isEnabled: warehouses.filter(isEnabled).length >= 2,
        isNotification: true
      };
      return [updatedWarehouse];
    }
    return displayedWarehouses;
  } else {
    displayedWarehouses = warehouses.filter((warehouse) => {
      return isPreferedWarehouse(warehouse) || isEnabled(warehouse);
    });
    if (displayedWarehouses.length === 1) {
      const updatedWarehouse = {
        ...displayedWarehouses[0],
        isEnabled: false,
        isNotification: true
      };
      return [updatedWarehouse];
    }
    return warehouses;
  }
};
const getNotificationMessage = ({
  preferredWarehouse,
  warehouses,
  allWHList,
  displayedWarehouses,
  stwErrorMessage,
  isLoading,
  isBatchLoading,
  isProductUnavailable,
  checked,
  msStore,
  drawerType
}) => {
  var _a, _b, _c, _d, _e;
  if (!isLoading) {
    const searchFailureAlertText = msStore.getKeyValueItem(
      SEARCH_FAILURE_TEXT_KEY
    );
    const unableToDetermineAvailabilityAlertText = msStore.getKeyValueItem(
      UNABLE_TO_DETERMINE_AVAILABILITY_ALERT_TEXT_KEY
    );
    const outOfStockAlertText = msStore.getKeyValueItem(
      OUT_OF_STOCK_ALERT_TEXT_KEY
    );
    const productUnavailableAlertText = msStore.getKeyValueItem(
      PRODUCT_UNAVAILABLE_ALERT_TEXT_KEY
    );
    const isPreferredWarehouseOrEmpty = !(warehouses == null ? void 0 : warehouses.length) || (warehouses == null ? void 0 : warehouses.length) === 1 && warehouses[0].warehouseId === preferredWarehouse;
    if (isPreferredWarehouseOrEmpty && !stwErrorMessage) {
      return {
        message: searchFailureAlertText,
        severity: "alert",
        uniqueId: "searchFailureAlertText"
      };
    }
    if (isPreferredWarehouseOrEmpty && stwErrorMessage || ((_a = displayedWarehouses == null ? void 0 : displayedWarehouses[0]) == null ? void 0 : _a.isNotification) === true && ((_b = displayedWarehouses == null ? void 0 : displayedWarehouses[0]) == null ? void 0 : _b.isEnabled) === false) {
      return {
        message: unableToDetermineAvailabilityAlertText,
        severity: "alert",
        uniqueId: "unableToDetermineAvailabilityAlertText"
      };
    }
    if (((_c = displayedWarehouses == null ? void 0 : displayedWarehouses[0]) == null ? void 0 : _c.isNotification) === true && ((_d = displayedWarehouses == null ? void 0 : displayedWarehouses[0]) == null ? void 0 : _d.isEnabled) === true) {
      return {
        message: outOfStockAlertText,
        severity: "alert",
        uniqueId: "outOfStockAlertText"
      };
    }
    if (drawerType === "CMW" && (warehouses == null ? void 0 : warehouses.length) && warehouses.length > 1 && !isBatchLoading && isProductUnavailable && !((_e = allWHList == null ? void 0 : allWHList.current) == null ? void 0 : _e.length) && checked) {
      return {
        message: productUnavailableAlertText,
        severity: "alert",
        uniqueId: "productUnavailableAlertText"
      };
    }
  }
  return null;
};
export {
  categorizeWH,
  getAvailableWHList,
  getNotificationMessage,
  getUnavailableWHList,
  getWHListDetails,
  getWHStockStatus,
  getWHToDisplay,
  markAllWHAsUnavailable,
  shouldShowSetWarehouseButton
};
